import { useTranslation } from "react-i18next";
import { Modal } from "../../common";
import { Button } from "../../App.styles";

const TitleModal = ({ onDismiss, show }) => {
    const { t } = useTranslation();

    return (
        <Modal onDismiss={onDismiss} show={show}>
            <div className="modal-header">
                <h4 className="modal-title" dangerouslySetInnerHTML={{ __html: t(`Name`) }} />
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-hidden="true"
                    onClick={onDismiss}
                >
                    ×
                </button>
            </div>
            <div className="modal-body">
                <p dangerouslySetInnerHTML={{
                    __html: t(`What is the name, title, or label you want users to see as 
                    their designation? Consider a theme when creating a set of designations. Eg. Wizard.`)
                }} />
            </div>
            <div className="modal-footer">
                <Button type="button" color="dark" data-dismiss="modal" onClick={onDismiss}>
                    {t(`Close`)}
                </Button>
            </div>
        </Modal>
    )
};

export default TitleModal;
